import { useState, useEffect } from 'react';
import { db } from '../utils/firebaseConfig';
import { collection, getDocs, setDoc, doc, deleteDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import './Jornadas.css';

const defaultFields = [
  { id: '1', name: 'nombre', label: 'Nombre Completo', type: 'text', required: true, order: 0, options: [] },
  { id: '2', name: 'email', label: 'Correo Electrónico', type: 'email', required: true, order: 1, options: [] },
  { id: '3', name: 'telefono', label: 'Teléfono', type: 'tel', required: true, order: 2, options: [] },
  { id: '4', name: 'experiencia', label: 'Experiencia en Futsal', type: 'select', required: false, order: 3, options: ['Principiante', 'Intermedio', 'Avanzado'] }
];

export default function AdminFormularios() {
  const [fields, setFields] = useState(defaultFields);
  const [newField, setNewField] = useState({
    name: '',
    label: '',
    type: 'text',
    required: false,
    options: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadFormConfig();
  }, []);

  const loadFormConfig = async () => {
    try {
      setLoading(true);
      setError('');

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout')), 5000)
      );

      const loadPromise = getDocs(collection(db, 'formConfig'));

      const querySnapshot = await Promise.race([loadPromise, timeoutPromise]);

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        const config = doc.data();
        const sortedFields = [...(config.fields || [])]
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        setFields(sortedFields);
      } else {
        setFields(defaultFields);
      }
    } catch (err) {
      console.error('Error loading config:', err);
      setFields(defaultFields);
    } finally {
      setLoading(false);
    }
  };

  const handleNewFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewField(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const addOrEditField = async (e) => {
    e.preventDefault();

    if (!newField.name || !newField.label) {
      setError('El nombre y etiqueta del campo son requeridos');
      return;
    }

    if (newField.type === 'select' && !newField.options) {
      setError('Debes agregar opciones para campos select');
      return;
    }

    try {
      setSaving(true);
      setError('');
      setSuccess('');

      let updatedFields;
      if (editingId) {
        updatedFields = fields.map(f =>
          f.id === editingId
            ? {
                ...f,
                name: newField.name,
                label: newField.label,
                type: newField.type,
                required: newField.required,
                options: newField.type === 'select'
                  ? newField.options.split('\n').filter(o => o.trim())
                  : []
              }
            : f
        );
        setEditingId(null);
      } else {
        const fieldObj = {
          id: uuidv4(),
          name: newField.name,
          label: newField.label,
          type: newField.type,
          required: newField.required,
          order: fields.length,
          options: newField.type === 'select'
            ? newField.options.split('\n').filter(o => o.trim())
            : []
        };
        updatedFields = [...fields, fieldObj];
      }

      setFields(updatedFields);

      try {
        await setDoc(doc(db, 'formConfig', 'config'), { fields: updatedFields });
      } catch (firebaseErr) {
        console.error('Firebase error:', firebaseErr);
      }

      setSuccess('Campo guardado correctamente');
      setNewField({ name: '', label: '', type: 'text', required: false, options: '' });
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error:', err);
      setError('Error al guardar el campo');
    } finally {
      setSaving(false);
    }
  };

  const deleteField = async (id) => {
    if (!window.confirm('¿Eliminar este campo?')) return;

    try {
      const updatedFields = fields.filter(f => f.id !== id);
      setFields(updatedFields);

      try {
        await setDoc(doc(db, 'formConfig', 'config'), { fields: updatedFields });
      } catch (firebaseErr) {
        console.error('Firebase error:', firebaseErr);
      }

      setSuccess('Campo eliminado');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al eliminar');
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>Cargando configuración...</div>;
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <h2 style={{ color: '#000', marginBottom: '20px', fontFamily: "'Oswald', sans-serif", fontSize: '24px', fontWeight: 'bold' }}>Configurar Campos del Formulario</h2>

      {error && <div style={{ backgroundColor: '#fee2e2', borderLeft: '4px solid #dc2626', padding: '12px', color: '#991b1b', marginBottom: '20px', borderRadius: '4px' }}>{error}</div>}
      {success && <div style={{ backgroundColor: '#f0fdf4', borderLeft: '4px solid #16a34a', padding: '12px', color: '#166534', marginBottom: '20px', borderRadius: '4px' }}>{success}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '40px' }}>
        {/* Formulario para agregar/editar campo */}
        <div>
          <h3 style={{ color: '#333', marginBottom: '15px', fontSize: '18px', fontWeight: 'bold' }}>Agregar/Editar Campo</h3>
          <form onSubmit={addOrEditField} style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '14px' }}>Nombre del campo:</label>
              <input
                type="text"
                name="name"
                value={newField.name}
                onChange={handleNewFieldChange}
                placeholder="ej: email"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', fontFamily: 'inherit' }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '14px' }}>Etiqueta (para mostrar):</label>
              <input
                type="text"
                name="label"
                value={newField.label}
                onChange={handleNewFieldChange}
                placeholder="ej: Correo Electrónico"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', fontFamily: 'inherit' }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '14px' }}>Tipo:</label>
              <select
                name="type"
                value={newField.type}
                onChange={handleNewFieldChange}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', fontFamily: 'inherit' }}
              >
                <option value="text">Texto</option>
                <option value="email">Email</option>
                <option value="tel">Teléfono</option>
                <option value="number">Número</option>
                <option value="textarea">Área de texto</option>
                <option value="select">Seleccionar</option>
              </select>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                <input
                  type="checkbox"
                  name="required"
                  checked={newField.required}
                  onChange={handleNewFieldChange}
                  style={{ marginRight: '8px' }}
                />
                Requerido
              </label>
            </div>

            {newField.type === 'select' && (
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '14px' }}>Opciones (una por línea):</label>
                <textarea
                  name="options"
                  value={newField.options}
                  onChange={handleNewFieldChange}
                  placeholder="Opción 1&#10;Opción 2&#10;Opción 3"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', minHeight: '80px' }}
                />
              </div>
            )}

            <button
              type="submit"
              disabled={saving}
              style={{ width: '100%', backgroundColor: '#000', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.6 : 1 }}
            >
              {saving ? 'Guardando...' : editingId ? 'Actualizar Campo' : 'Agregar Campo'}
            </button>
          </form>
        </div>

        {/* Lista de campos */}
        <div>
          <h3 style={{ color: '#333', marginBottom: '15px', fontSize: '18px', fontWeight: 'bold' }}>Campos Actuales</h3>
          <div style={{ backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
            {fields.length === 0 ? (
              <div style={{ padding: '20px', color: '#999', textAlign: 'center' }}>No hay campos configurados</div>
            ) : (
              fields.map(field => (
                <div key={field.id} style={{ padding: '15px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', color: '#333', marginBottom: '3px' }}>{field.label}</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>{field.type}{field.required ? ' • Requerido' : ''}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <button
                      onClick={() => setNewField({ name: field.name, label: field.label, type: field.type, required: field.required, options: field.options.join('\n') }) || setEditingId(field.id)}
                      style={{ padding: '6px 12px', backgroundColor: '#667eea', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => deleteField(field.id)}
                      style={{ padding: '6px 12px', backgroundColor: '#f44336', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
